<script>
import CaseListItemComponent from "@/components/Cases/CaseListItemComponent.vue";
import cases from "@/api/cases";

export default {
  name: "CaseListComponent",
  components: { CaseListItemComponent },

  data() {
    return {
      cases: [],
      loading: true,

      filter: {
        search: "",
        project_type_id: null
      }
    }
  },

  computed: {
    filteredCases() {
      let result = this.cases

      if (this.filter.search) {
        const query = this.filter.search.toLowerCase()

        result = result.filter(c =>
          (c.title && c.title.toLowerCase().includes(query)) ||
          (c.problem && c.problem.toLowerCase().includes(query)) ||
          (c.company_name && c.company_name.toLowerCase().includes(query))
        );
      }

      if (this.filter.project_type_id) {
        result = result.filter(
          c => c.project_type_id === this.filter.project_type_id
        )
      }

      return result
    },

    projectTypes() {
      return this.$store.state.projects.project_types || []
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('getProjectTypes');
    this.cases = (await cases.all()).data
    this.loading = false
  }
}
</script>

<template>
  <v-container>
    <v-row align="center" class="mb-4">
      <v-col cols="12" md="6" class="d-flex align-center" style="gap: 10px">
        <h1>Кейсы</h1>
        <v-btn
            v-if="['employee', 'company'].includes($store.state.user.currentUser.role)"
            color="blue"
            light
            outlined
            style="border-radius: 10px"
            elevation="0"
            to="/cases/create"
        >
          Добавить кейс
        </v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <v-row >
          <v-col cols="6">
            <v-text-field
                v-model="filter.search"
                label="Поиск по кейсам"
                outlined
                clearable
                dense
                height="40px"
                hide-details
                class="white mb-0"
                style="border-radius: 10px;"
            />
          </v-col>
          <v-col cols="6">
            <v-select
                v-model="filter.project_type_id"
                :items="projectTypes"
                item-text="name"
                item-value="id"
                label="Тип проекта"
                outlined
                clearable
                dense
                height="40px"
                hide-details
                class="white mb-0"
                style="border-radius: 10px;"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="loading"></v-row>
    <v-row v-else>
      <v-col v-for="projectCase in filteredCases" :key="projectCase.id" sm="12" cols="12" md="4" lg="4">
        <CaseListItemComponent :projectCase="projectCase" />
      </v-col>
      <v-col cols="12" v-if="filteredCases.length === 0">
        <v-alert type="info" text>
          Кейсы не найдены
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped></style>